import { generateClientSeed } from "../../../utils/common.helper"
import { GAME_STATES } from "./constants"

let _isDemo = false;

export const demoState = {
    get isDemo() {
        return _isDemo;
    },
    set isDemo(value) {
        _isDemo = Boolean(value);
    }
};

export const networkData = {
    gameResult: "pending",
    operatorUserToken: null,
    operatorId: 1,
    jwtToken: null,
    userCode: 'USER002',
    currencyCode: 'PHP',
    gameId: 1,
    dataWithJwt: null,
    // clientSeed: "SAVZVGHSD1@gf12b32",
    clientSeed: generateClientSeed()?.seed,
    dataLastPendingBet: null,
    dataBuyTickets: null,
    dataPlaceBet: null,
    dataScratchScore: null,
    scratchResult: null,
    ticketDetails: null,
    buyTickets: null,
    insufficientAmount: false,
    winAmount: 0,
    jackpot: false,
    jackpotMinorWin: 0,
    jackpotMajorWin: 0,
    jackpotGrandWin: 0,
    jackpotMinorWinAmount: 0,
    jackpotMajorWinAmount: 0,
    jackpotGrandWinAmount: 0,
    lastJackpot: null,
    ticketsPurchased: 0,
    ticketsLeft: 0,
    winType: null,
    gamePoint: 4,
    betPoint: 6,
    allFlagValues: [],
    turboData: false,
    betArray: [],
    roundArray: [],
    isJackpot: false,
    currentTicket:0,
    grandCurrentJackpotValue: 0,
    majorCurrentJackpotValue: 0,
    minorCurrentJackpotValue: 0,
    resetGrandJackpotValue:0,
    resetMajorJackpotValue:0,
    resetMinorJackpotValue:0,
    ticketError: false,
    response: null,
    showAutoTurbo: true,
    betHist: []
}

export const gameData = {
    betAmount: "1",
    pixiStates: null,
    gameState: GAME_STATES.IDLE,
    scratchDoneNumber: 0,
    isPopupOpen: false,
    numberOfGames: 1,
    autoPlayInProgress: false,
    autoPlay: false,
    turboPlay: false,
    scratchIndex: [],
    flagInProgress: false,
    notScratched: [],
    scratchedValues: [], 
    gameVersion : "1.3.07",
    winGame: null,
    flagValues : [1, 2, 2.5, 5, 10, 100, 500, 1000, 10000],
    demoBetValues: [100, 50, 20, 10, 5, 2],
    demoGamesValues: ['50 Games', '25 Games', '10 Games', '5 Games' , '1 Game'],
    balance: 1000,
    demoGameCount: 1,
    ticketsRemaining: false,
    winNumber: 0,
    multiplierVal: 0,
    showAmount: false,
    winOver: false,
    gameLanguage: 'en',
    firstScratchDone: false,
    showWin: false,
    winType: null,
    showWinAmount: false,
    flagValue : 0,
    bgPointer: 1,
    pigAndChickenDelay: null,
    grandFlag: 0,
    minorFlag: 0,
    majorFlag: 0,
    tutScroll: false,
    stopPos: 0,
    dragPos: 0,
    ftueStopPos: 0,
    ftueDragPos: 0,
    ftueScroll: false,
    betHistoryLeft: false,
    betHistoryRight: false
}

export const pixiDiv = {
    width: null,
    height: null
}


